module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('Drawer'), _vm._v(" "), _c('Modal'), _vm._v(" "), _c('InformationPopup')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "map"
  }, [_c('div', {
    staticClass: "google-maps",
    attrs: {
      "id": "map"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48bf5bdb","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=1udq9m5yalv!./~/string-replace-webpack-plugin/loader.js?id=5v3roo83miv!./src/components/threatened-species/ThreatenedSpeciesMap.vue
// module id = 757
// module chunks = 0